export const parseMarketScope = (raw: any): string[] => {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw.map((s: string) => s.trim().toUpperCase());
  if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return parsed.map((s: string) => s.trim().toUpperCase());
    } catch {
      return raw.split(',').map((s) => s.trim().toUpperCase());
    }
  }
  return [];
};
